export const state = () => ({
  isOpenClassModal: false,
  showAdvertising: false,
  noAdvertising: false,
  success: {
    isOpen: false,
    title: '',
    description: '',
  },
})

export const mutations = {
  toggleClassModal(state) {
    state.isOpenClassModal = !state.isOpenClassModal
  },
  toggleAdvertising(state) {
    state.showAdvertising = !state.showAdvertising
  },
  toggleSuccessModal(state) {
    state.success.isOpen = !state.success.isOpen
  },
  setSuccessTitle(state, msg) {
    state.success.title = msg
  },
  setSuccessDescription(state, msg) {
    state.success.description = msg
  },
  showAdvertising(state) {
    state.showAdvertising = true
  },
  noAdvertising(state) {
    state.noAdvertising = true
  },
}
